import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eiw5tz7npc: FaireBrandEntity = {
  token: "b_eiw5tz7npc",
  type: "brand",
  name: "Sugarlips",
  avatarUrl:
    "https://cdn.faire.com/fastly/0fafb9d87fe07263e02d5f680badb2ca2b9b4fe76a92c2f923bf556f5f527e50.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7671d734f1af2e807a7f76c2dd1acf4b16fb01dee726174f8a65e2a5252ba71c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0fafb9d87fe07263e02d5f680badb2ca2b9b4fe76a92c2f923bf556f5f527e50.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7671d734f1af2e807a7f76c2dd1acf4b16fb01dee726174f8a65e2a5252ba71c.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.7,
  reviewCount: 673,
  isInsider: true,
  description:
    "Sugarlips©, founded in 2002, is a full range women's clothing brand located in the heart of Los Angeles, CA.\n\nSugarlips started with just a small line of sweaters and within a few years, became the largest manufacturer of seamless apparel in North America. Sugarlips has expanded its line and now produces fashionable clothing at affordable prices.\n\nThe Sugarlips team of designers is constantly pushing the envelope to innovate and create revolutionary pieces of clothing. With hundreds of new designs created each month, Sugarlips stays ahead of the trends to provide its customers with the latest looks. Sugarlips fashion pieces are carried nationwide by some of the largest department stores as well as thousands of boutiques. The Sugarlips line of fashion clothing is high quality, contemporary style pieces at affordable prices.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:47.599Z",
    importedBy: "entity-db-cli",
  },
};
